import { Model } from '@/models/Model';
export class School extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'School';
        this.$endpoint = '/schools';
        this.$fillable = ['id', 'name', 'email', 'avatar', 'settings'];
    }
}
export var SchoolIncludes;
(function (SchoolIncludes) {
    SchoolIncludes["AMOUNT_OF_STUDENTS"] = "amount_of_students";
})(SchoolIncludes || (SchoolIncludes = {}));
